const release = '0.13.6'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js